import { Inject, Injectable } from '@angular/core';
import { SecurityCorrelationMatrix } from '@blk/wealth-web-endpoint';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { AppStoreConfig, PositionDetails, WweFeature } from '@ddt-web/data-service';
import { StoreService } from '@ddt-web/store-service';

import { WwePortfolioPosition } from '../domain/objects/wwe-portfolio-positions.model';


@Injectable({
	providedIn: 'root'
})
export class WealthWebDataService {

	constructor(
		private storeService: StoreService,
		@Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig
	) { }

	public loadPositionData(
		mappedPortfolios: WwePortfolioPosition[],
		feature?: WweFeature,
		positionDetailsType: string = PositionDetails.SECURITY_DETAILS_API_TYPE.SECURITY_DETAILS
	): void {
		const store = this.storeConfig[PositionDetails.SECURITY_DETAILS_STORE_MAPPING[positionDetailsType]] || this.storeConfig.positionDetails;

		if (feature === WweFeature.COMPARE) {
			this.storeService.upsertMany(this.storeConfig.positionDetailsCompare, mappedPortfolios);
		} else {
			this.storeService.upsertMany(store, mappedPortfolios);
		}
	}

	public loadCorrelationMatrixData(portfolioIds: string[], data: SecurityCorrelationMatrix[]): void {
		const portfolioIdToCorrelationMatrix = portfolioIds.map(id => {
			return { id, matrix: data };
		});

		this.storeService.upsertMany(this.storeConfig.correlationMatrix, portfolioIdToCorrelationMatrix);
	}
}
